import axios from "axios";
import { SystemSettingActions } from "./systemSettingAction";
import { showSuccessSnackbar } from "../../snackBar/snackBar.action";

//get all System Setting api
export const getAllSystemSettingAsync = () => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = process.env.REACT_APP_BASE_URL;

      dispatch(SystemSettingActions.getAllSystemSettingStart());
      const { data } = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/systemSettings/getAllSystemSettings`,
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (data.statusCode === 200) {
        return dispatch(SystemSettingActions.getAllSystemSettingSuccess(data));
      }
      dispatch(SystemSettingActions.getAllSystemSettingError());
    } catch (error) {
      dispatch(SystemSettingActions.getAllSystemSettingError());
      dispatch(showSuccessSnackbar("error", "Error while fetching data", 3000));
    }
  };
};

//update System Setting api
export const updateSystemSettingAsync = (
  setting_id,
  values,
  setSubmitting = () => {},
  // resetForm = () => {},
  redirectBack = () => {}
) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = process.env.REACT_APP_BASE_URL;

      dispatch(SystemSettingActions.updateSystemSettingStart());
      const { data } = await axios({
        method: "PUT",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/systemSettings/editSystemSetting/${setting_id}`,
        headers: {
          "Content-Type": "application/json",
        },
        data: values,
      });
      if (data.statusCode === 200) {
        dispatch(SystemSettingActions.updateSystemSettingSuccess(data));
        setSubmitting(false);
        // resetForm();
        redirectBack();
        return dispatch(
          showSuccessSnackbar(
            "success",
            "System Setting Updated Successfully",
            3000
          )
        );
      }
      dispatch(SystemSettingActions.updateSystemSettingError());
      setSubmitting(false);
      return dispatch(showSuccessSnackbar("error", data.responseMessage, 3000));
    } catch (error) {
      setSubmitting(false);
      // resetForm();
      dispatch(SystemSettingActions.updateSystemSettingError(error));
      dispatch(showSuccessSnackbar("error", error.data.message, 3000));
    }
  };
};
